import { render, staticRenderFns } from "./settings-button.component.vue?vue&type=template&id=8cf88814"
import script from "./settings-button.component.vue?vue&type=script&lang=js"
export * from "./settings-button.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports